module.exports = __webpack_public_path__ + "static/img/insights.8c0d245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile/insights.png
// module id = sMxq
// module chunks = 37